import _ from 'lodash';

const initialState = {
  source: {
    linkId: null,
    linkKey: null,
  },
  task: null,
  customSuccessToastEnabled: false,
  onCreate: null,
  onUpdate: null,
  onDelete: null,
  checkSaveAllowed: null,
  checkActionAllowed: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'TASK_FORM_SET_SOURCE': {
      return {
        ...state,
        source: action.source,
      };
    }

    case 'TASK_FORM_SET_SHOW_FORM': {
      return {
        ...state,
        source: action.source,
        onCreate: action.onCreate ? action.onCreate : state.onCreate,
        onUpdate: action.onUpdate ? action.onUpdate : state.onUpdate,
        onDelete: action.onDelete ? action.onDelete : state.onDelete,
        customSuccessToastEnabled: action.customSuccessToastEnabled
          ? action.customSuccessToastEnabled
          : state.customSuccessToastEnabled,
      };
    }

    case 'TASK_FORM_SET_TASK': {
      return {
        ...state,
        task: action.task,
      };
    }

    case 'TASK_FORM_SET_CUSTOM_SUCCESS_ENABLED': {
      return {
        ...state,
        customSuccessToastEnabled: action.customSuccessToastEnabled,
      };
    }

    case 'TASK_FORM_SET_ON_CREATE': {
      return {
        ...state,
        onCreate: action.onCreate,
      };
    }

    case 'TASK_FORM_SET_ON_UPDATE': {
      return {
        ...state,
        onUpdate: action.onUpdate,
      };
    }

    case 'TASK_FORM_SET_ON_DELETE': {
      return {
        ...state,
        onUpdate: action.onDelete,
      };
    }

    case 'TASK_FORM_SET_EVENT_LISTENERS': {
      return {
        ...state,
        onUpdate: action.onUpdate ? action.onUpdate : state.onUpdate,
        onCreate: action.onCreate ? action.onCreate : state.onCreate,
        onDelete: action.onDelete ? action.onDelete : state.onDelete,
      };
    }

    case 'TASK_FORM_SET_FUNCTIONS': {
      return {
        ...state,
        checkSaveAllowed: action.checkSaveAllowed
          ? action.checkSaveAllowed
          : state.checkSaveAllowed,
        checkActionAllowed: action.checkActionAllowed
          ? action.checkActionAllowed
          : state.checkActionAllowed,
      };
    }

    case 'TASK_FORM_CLEAR_FUNCTIONS': {
      return {
        ...state,
        checkSaveAllowed: null,
        checkActionAllowed: null,
      };
    }

    case 'TASK_FORM_RESET':
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
